import type { LicenseAccountFragment } from "@/v2-backoffice-client/license/account/__types__/license.account.fragment"

export const UNMATCHED_STATUS = "Unmatched"
export const ACKNOWLEDGED_STATUS = "Acknowledged"
export const LINKED_STATUS = "Linked"
export const ARCHIVED_STATUS = "Archived"

export type LicenseAccountLinkStatus =
  | typeof UNMATCHED_STATUS
  | typeof ACKNOWLEDGED_STATUS
  | typeof LINKED_STATUS
  | typeof ARCHIVED_STATUS

/**
 * The link-status bucket the board's pills and the Licensing page's
 * attention chip both classify by. Linked rows keep the Linked status even
 * when Fenerum archives the account — the link persists and keeps
 * mirroring; Archived is only the "unlinked and nothing to do" bucket.
 * Acknowledged is an unmatched row an operator reviewed and explained
 * (intentional group billing, duplicate account being consolidated) — same
 * data state as Unmatched, but off the needs-review worklist.
 */
export function getLinkStatus(
  account: LicenseAccountFragment,
): LicenseAccountLinkStatus {
  if (account.CustomerId !== null && account.CustomerId !== undefined) {
    return LINKED_STATUS
  }
  if (account.IsArchived) return ARCHIVED_STATUS
  return account.ReviewedAt ? ACKNOWLEDGED_STATUS : UNMATCHED_STATUS
}
